import { render, staticRenderFns } from "./SmsTextBox.vue?vue&type=template&id=58ac9a02&scoped=true"
import script from "./SmsTextBox.vue?vue&type=script&lang=js"
export * from "./SmsTextBox.vue?vue&type=script&lang=js"
import style0 from "./SmsTextBox.vue?vue&type=style&index=0&id=58ac9a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ac9a02",
  null
  
)

export default component.exports